module.exports = __webpack_public_path__ + "img/pay-welfare-btn.65bc0c22.png";